import { Injectable } from '@angular/core';
import { InfoService } from 'src/app/domain/service';
import { CommonToolService } from './common-tool.service';
import { GridBodyCtrl } from '@ag-grid-community/core';

@Injectable()
export class AggridHelperService {
  constructor(
    private infoService: InfoService,
    private ct: CommonToolService
  ) {}

  getFormattedValue(obj, originalVal?) {
    var v = obj.valueFormatted ? obj.valueFormatted : obj.value;
    if (v == '-' && !originalVal) return null;
    return v;
  }

  //#region valueFormatter
  //needBracket--  wrap with brackets if the value is less than zero. default is true.
  numberDefaultValueFormater(
    format?,
    notShowGroup?,
    notShowFooter?,
    needBracket?
  ) {
    return (params) => {
      if (notShowGroup && params.node.group && params.api) {
        var columns = params.api.getColumns();
        if (
          columns.length > 0 &&
          (columns[0].colId != params.colDef.field || params.node.isFirst)
        ) {
          //The first column need the value to display.
          return '';
        }
      }

      if (notShowFooter && params.api && params.node.rowPinned == 'bottom') {
        return '';
      }
      format = format || this.infoService.getNumberDigits();
      var v = this.getFormattedValue(params);
      if (this.ct.isNullOrUndefined(v) || v === '-' || v === '') {
        return '-';
      } else {
        if (v < 0 && (needBracket === undefined || needBracket == true)) {
          return '(' + this.ct.numberFormatter(Math.abs(v), format) + ')';
        }
        if (!isNaN(v)) {
          return this.ct.numberFormatter(parseFloat(v + ''), format);
        } else {
          return v;
        }
      }
    };
  }
  percentageDefaultValueFormater(format?) {
    return (params) => {
      //when this formatter wasn't called by the aggrid, this params.api is undefined
      var columns = params.api ? params.api.getColumns() : null;
      //if columns is null, that mean this formatter is called by the external, for this case the params paramter's node.isFirst property can represent first column.
      if (
        (!params.node.group && params.node.rowPinned == undefined) ||
        ((!columns || columns[0].colId === params.colDef.field) &&
          params.node.isFirst)
      ) {
        var v = this.getFormattedValue(params);
        if (!this.ct.isNullOrUndefined(v) && v !== '-' && v !== '') {
          format = format || this.infoService.getPercentageDigits();
          var v = this.getFormattedValue(params);
          if (this.ct.isNullOrUndefined(v)) {
            return '';
          } else {
            if (!isNaN(v)) {
              if (v < 0) {
                return (
                  '(' + this.ct.percentFormatter(Math.abs(v), format) + ')'
                );
              } else {
                return this.ct.percentFormatter(v, format);
              }
            } else {
              return v;
            }
          }
        } else {
          return '-';
        }
      } else {
        return '';
      }
    };
  }
  dateDefaultValueFormater(format?) {
    return (params) => {
      //when this formatter wasn't called by the aggrid, this params.api is undefined
      var columns = params.api ? params.api.getColumns() : null;
      //if columns is null, that mean this formatter is called by the external, for this case the params paramter's node.isFirst property can represent first column.
      if (
        (params.node &&
          !params.node.group &&
          params.node.rowPinned == undefined) ||
        ((!columns || columns[0].colId === params.colDef.field) &&
          params.node &&
          params.node.isFirst) ||
        ((!columns || columns[0].colId === params.colDef.field) &&
          params.rowIndex >= 0)
      ) {
        var v = this.getFormattedValue(params);
        if (!this.ct.isNullOrUndefined(v) && v != '-' && v != '') {
          format = format || this.infoService.getDateFormat();
          if (typeof v == 'string') {
            try {
              var date = new Date(v);
              return this.ct.dateFormatter(date, format);
            } catch {
              v = parseInt(v);
              var date = new Date(v);
              return this.ct.dateFormatter(date, format);
            }
          } else {
            var date = new Date(v);
            return this.ct.dateFormatter(date, format);
          }
        } else {
          return '-';
        }
      } else {
        return '';
      }
    };
  }

  stringDefaultValueFormater() {
    return function (params) {
      var columns = params.api ? params.api.getColumns() : null;
      if (
        (params.node.group || params.node.rowPinned == 'bottom') &&
        ((columns && columns[0].colId != params.colDef.field) ||
          !params.node.isFirst)
      ) {
        return '';
      } else {
        var v = this.getFormattedValue(params);
        if (!this.ct.isNullOrUndefined(v) && v != '-' && v != '') {
          return v;
        } else {
          return '-';
        }
      }
    };
  }
  defaultFirstColumnCellRennder(dataLevelFormatter?) {
    return (params) => {
      if (params.node.group) {
        var groupID = params.node.rowGroupColumn.colId,
          groupValue = params.node.allLeafChildren[0].data[groupID],
          formatter = params.node.rowGroupColumn.colDef.valueFormatter,
          val = this.getFormattedValue(params, true);
        if (formatter) {
          params.node.isFirst = true;
          val = formatter({ value: groupValue, node: params.node });
        }
        if (this.ct.isNullOrUndefined(val) || val == '-' || val === '') {
          val = '-';
        }
        if (params.colDef.aggFunc) {
          //allLeafChildren
          var field = params.colDef.field,
            value = params.node.aggData[field];
          if (this.ct.isNullOrUndefined(value) || value === '') {
            value = 0;
            params.node.allLeafChildren.forEach(function (item) {
              var v = item.data[field];
              if (!this.ct.isNullOrUndefined(v) && !isNaN(v)) {
                value += parseFloat(v + '');
              }
            });
            if (
              this.ct.isNullOrUndefined(value) ||
              value == '-' ||
              value === ''
            ) {
              value = '-';
            }
            return val + '(' + params.formatValue(value) + ')';
          } else {
            if (
              this.ct.isNullOrUndefined(value) ||
              value == '-' ||
              value === ''
            ) {
              value = '-';
            }
            return val + '(' + params.formatValue(value) + ')';
          }
        } else {
          return val;
        }
      } else {
        var value = this.getFormattedValue(params, true);
        //The 'value===""' condition is not requried, because the valueFormatter function will return an empty string value to here when the currenty column has no footer.
        //So, If the value is empty, we just to return empty string back.
        if (this.ct.isNullOrUndefined(value) || value == '-') {
          value = '';
        }
        return dataLevelFormatter ? dataLevelFormatter(params, true) : value;
      }
    };
  }
  //#endregion

  aggFuncRunnerFactory(field, func, calculator?, formatFun?) {
    //Used for the footer aggregation calculation
    if (!calculator) {
      calculator = function (dataItem, field) {
        return dataItem[field];
      };
    }
    if (func == 'average') {
      func = 'avg';
    }
    var result = null,
      length = 0,
      sum = 'sum',
      max = 'max',
      min = 'min',
      avg = 'avg',
      value = 'value';
    var accAdd = function (arg1, arg2) {
      let r1, r2, m;
      try {
        r1 = arg1.toString().split('.')[1].length;
      } catch (e) {
        r1 = 0;
      }
      try {
        r2 = arg2.toString().split('.')[1].length;
      } catch (e) {
        r2 = 0;
      }
      m = Math.pow(10, Math.max(r1, r2));
      return (arg1 * m + arg2 * m) / m;
    };
    return {
      setDataItem: function (dataItem) {
        var val = calculator(dataItem, field);
        if (func == value) {
          if (result == null) {
            result = val;
          }
        } else {
          if (!isNaN(val)) {
            if (func == sum || func == avg) {
              if (result == null) {
                result = val;
              } else {
                result = accAdd(result, val);
              }
            } else if (func == max || func == min) {
              if (result == null) {
                result = val;
              } else {
                if (
                  (func == max && result < val) ||
                  (func == min && result > val)
                ) {
                  result = val;
                }
              }
            }
          }
        }
        length++;
      },
      run: function () {
        if (func == sum || func == min || func == max) {
          if (formatFun && typeof formatFun == 'function') {
            result = formatFun(result);
          }
          return { field: field, value: result };
        } else if (func == avg) {
          result = result / length;
          if (formatFun && typeof formatFun == 'function') {
            result = formatFun(result);
          }
          return { field: field, value: result };
        } else if (func == value) {
          if (formatFun && typeof formatFun == 'function') {
            result = formatFun(result);
          }
          return { field: field, value: result };
        }
      },
    };
  }

  applyFooterAggregates(
    data,
    columns,
    calculationColumns?,
    attributesFooterAggregates?
  ) {
    var aggregateRunners = [];
    calculationColumns &&
      calculationColumns.forEach((calc) => {
        if (calc.footeroperators.length > 0) {
          aggregateRunners.push(
            this.aggFuncRunnerFactory(calc.field, calc.footeroperators[0])
          );
        }
      });
    attributesFooterAggregates &&
      attributesFooterAggregates.forEach((agg) => {
        aggregateRunners.push(
          this.aggFuncRunnerFactory(agg.field, agg.aggregate)
        );
      });

    columns.forEach((col) => {
      if (col.footerTemplate || col.footerValueCalculator) {
        aggregateRunners.push(
          this.aggFuncRunnerFactory(
            col.field,
            'sum',
            col.footerValueCalculator,
            col.footerFormatFun
          )
        );
      }
    });

    data.forEach((dataItem) => {
      aggregateRunners.forEach(function (runner) {
        runner.setDataItem(dataItem);
      });
    });
    var results = {};
    aggregateRunners.forEach((runner) => {
      var result = runner.run();
      if (result) {
        //if func is an unknown aggregate function, that the result is undefined
        results[result.field] = result.value;
      }
    });
    columns.forEach(function (col) {
      if (results[col.field] == undefined) {
        results[col.field] = null;
      }
    });

    return results;
  }

  autoSizeColumns(grid, exceptColIds?, trunExceptToTarget?, isFit?): void {
    //trunExceptToTarget: turn the except colids to the target colids;
    var allColumnIds = [];
    if (!trunExceptToTarget) {
      exceptColIds = exceptColIds || [];
      grid.api.getColumns().forEach(function (column) {
        if (exceptColIds.indexOf(column.colId) == -1) {
          allColumnIds.push(column.colId);
        }
      });
    } else {
      allColumnIds = exceptColIds;
    }
    grid.api.autoSizeColumns(allColumnIds);
    let gridBodyCtrl = (grid.api as any).gridBodyCtrl as GridBodyCtrl,
      viewportEl = gridBodyCtrl.getBodyViewportElement();
    let colsViewportEl = viewportEl.querySelector('.ag-center-cols-viewport'),
      colsContainerEl = viewportEl.querySelector('.ag-center-cols-container');
    if (colsViewportEl && colsContainerEl) {
      let viewportWidth = colsViewportEl.getBoundingClientRect().width,
        containerWidth = colsContainerEl.getBoundingClientRect().width;
      if (containerWidth < viewportWidth) {
        grid.api.sizeColumnsToFit();
      }
    }
  }
}
